import MiniSimilarProducts from './miniSimilarProducts'

export default MiniSimilarProducts
